import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GeneralService} from '../../../services/general.service';
import {Option, Response, StaticMethods} from '../../../model/GeneralModels';
import {IntroductionLetterService} from '../../../services/introduction-letter.service';
import {ActivatedRoute, Params, Router} from '@angular/router';

@Component({
  selector: 'app-create-introduction-letter',
  templateUrl: './create-introduction-letter.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class CreateIntroductionLetterComponent implements OnInit {
  formGroup: FormGroup = this.fb.group({
    companyName: ['', Validators.required],
    productName: ['', Validators.required],
    offerID: ['', Validators.required],
  });
  companies: Option[] = [];
  products: Option[] = [];
  insuranceNumber: string;
  productName: string;
  offers: Option[] = [];
  private translation: any;

  constructor(private fb: FormBuilder, private generalService: GeneralService,
              private activatedRoute: ActivatedRoute,
              private introductionLetterService: IntroductionLetterService,
              private router: Router) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.productName = params.productName;
      if (StaticMethods.checkState(this.router, 'insuranceNumber', `/insurance-service/${this.productName}/basic-information`)) {
        this.insuranceNumber = history.state.insuranceNumber;
        this.generalService.getClientCompanyList(this.productName).subscribe((response: Response) => {
          if (response.success) {
            this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
            this.companies = this.populateList(response);
            if (this.companies.length === 1) {
              this.formGroup.controls.companyName.patchValue(this.companies[0].value);
            }
          }
        });
        this.introductionLetterService.getClientProductList().subscribe((response: Response) => {
          if (response.success) {
            this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
            this.products = this.populateList(response);
            if (this.products.length === 1) {
              this.formGroup.controls.productName.patchValue(this.products[0].value);
            }
          }
        });
      }
    });
  }

  getOfferList() {
    const companyName = this.formGroup.controls.companyName.value;
    const productName = this.formGroup.controls.productName.value;
    if (companyName && productName) {
      this.introductionLetterService.getOfferList(companyName, productName).subscribe(response => {
        if (response.success) {
          this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
          this.offers = this.populateList(response);
        }
      });
    }
  }

  private populateList(response: Response) {
    const array = [];
    response.data.forEach(object => {
      array[array.length] = new Option(object.label, object.value);
    });
    return array;
  }

  goNext() {
    if (this.formGroup.valid) {
      const state = {
        insurance: this.formGroup.value
      };
      state.insurance.insuranceNumber = this.insuranceNumber;
      state.insurance.multipleSubRequests = state.insurance.productName === 'HEALTH';
      state.insurance.subsetList = [];
      this.router.navigate([`/insurance-service/${this.productName}/new-request`], {
        state
      });
    }
  }
}
